import { tuple } from '../utils/types';

export type MinigameType = typeof minigameTypes[number];

export const minigameTypes = tuple('match3');

export const coinsLessThanToUnlockMinigames = 100;

export const getEnergyRequirement = (minigame: MinigameType) => 1;
